import store from '@/store'
import H_act from '@/helpers/act';
import H_time from '@/helpers/time';
import H_file from '@/helpers/file';
import H_common from '@/helpers/common';
import H_factoryTag from '@/helpers/factoryTag';
import H_guidelineVersionAdmin from '@/helpers/guidelineVersionAdmin';

export default {
  setIndex(rawDataList) {
    return rawDataList.map(({
      id,
      guideline_status,
      last_version,
      owner,
      factory_tags,
      has_unreleased,
      is_collect: isCollect = false,
    }) => {
      const hasUnreleased = has_unreleased === 1
        ? {
            text: '未發布',
            color: 'gray',
          }
        : {
            text: '發布',
            color: 'green',
          };
      const {
        name='',
        announce_at='',
      } = last_version ? last_version : {};
      const updateDateBadge = H_act.setActUpdateDateBadge(announce_at);
      return {
        id,
        name: {
          text: name,
          chips:  [
            ...(updateDateBadge ? [{
              name: updateDateBadge,
              color: 'yellow',
            }] : []),
            ...H_common.setFactoryTagsInDataTable(factory_tags),
          ],
        },
        guidelineStatus: {
          text: guideline_status ? guideline_status.name : '無',
          color: 'yellow',
        },
        announceAt: H_time.getDateDashFormat(announce_at),
        hasUnreleased,
        isCollect,
        owner,
      };
    })
  },
  setIndexParams(filterState) {
    const {search, factoryTags, hasUnreleased, owner, duration, guidelineStatus} = filterState;
      const {start, end} = duration;
      let baseParams = {
        factory: store.state.app.factory.id,
        order_by: 'announce_at',
        order_way: 'desc',
        owner: owner.toString(),
        guideline_status: guidelineStatus.toString(),
        factory_tags: factoryTags.toString(),
      };
      if (search) baseParams.search = search;
      if (start && end) baseParams = {
        ...baseParams,
        time_field: 'announce_at',
        start_time: start,
        end_time: end,
      };
      if (hasUnreleased) baseParams.has_unreleased = hasUnreleased.toString();
      return baseParams;
  },
  setShow({
    id,
    factory_tags,
    guideline_status,
    last_version: lastVersion,
    has_unreleased: hasUnreleased,
    owner,
    users,
    user_factory_role_templates,
    user_factory_roles,
    has_related_models: hasRelatedModels,
  }) {
    const tempRoles = user_factory_role_templates.map(role => role.name);
    const factoryRoles = user_factory_roles.map(role => role.name);
    const roles = [...tempRoles, ...factoryRoles].join(', ');
    return {
      id,
      versionId: lastVersion ? lastVersion.id : '',
      lastVersion,
      factoryTags: H_factoryTag.setShowInModule(factory_tags),
      guidelineStatus: guideline_status ? guideline_status.name : '無',
      guidelineStatusId: guideline_status ? guideline_status.id : '',
      announceStatus: hasUnreleased === 1 ? '未發布' : '發布',
      owner,
      users,
      roles,
      hasUnreleased,
      hasRelatedModels,
    }
  },
  setEditPopup(type, sourceItem) {
    const baseData = {
      type,
      isValidate: false,
    };
    const settingMap = {
      'create': {
        title: '新增',
      },
      'edit': {
        title: '編輯',
      },
      'createInside': {
        title: '新增',
        placement: '',
        relation: '',
        sourceItem,
      },
      'createVersion': {
        title: '建立新版本',
      }
    };
    return {
      ...baseData,
      ...settingMap[type] || {
        title: '',
      },
    };
  },
  setCreateSubmit({
    name,
    owner,
    factoryTags,
    announceAt,
    effectAt,
    guidelineStatus: guideline_status,
    remark,
    attaches,
    lawList,
    scopeAvatars: users,
    scopeRoles,
    guidelineList,
  }) {
    const {user_factory_roles, user_factory_role_templates} = H_common.setSubmitRolesAndFactoryRoles(scopeRoles);
    const { actVersionAlls: act_version_alls, articleVersions: article_versions } = H_common.setSubmitActAndArticle(lawList);
    return {
      name,
      owner,
      announce_at: H_time.getDateDashFormat(announceAt, 'YYYY-MM-DD HH:mm:ssZ'),
      effect_at: H_time.getDateDashFormat(effectAt, 'YYYY-MM-DD HH:mm:ssZ'),
      remark,
      guideline_status,
      users,
      user_factory_roles,
      user_factory_role_templates,
      factory_tags: factoryTags[0],
      attaches: H_file.setSubmitInModule(attaches),
      article_versions,
      act_version_alls,
      related_guidelines: H_guidelineVersionAdmin.setSubmitRelatedGuideline(guidelineList),
    };
  },
  setUpdateShow({
    id,
    last_version,
    owner,
    factory_tags,
    guideline_status,
    users,
    user_factory_roles,
    user_factory_role_templates,
  }) {
    const {
      id: versionId = '',
      name = '',
      remark = '',
      attaches = [],
      act_version_alls = [],
      article_versions = [],
      announce_at = '',
      effect_at = '',
      related_guidelines = [],
    } = last_version ? last_version : {};
    const lawList = H_common.setLawList({
      act_version_alls,
      article_versions,
    });
    return {
      id,
      versionId,
      name,
      remark,
      attaches: H_file.setShowInModule(attaches),
      lawList,
      owner: owner.id,
      ownerSelectValue: owner,
      factoryTags: [factory_tags.map(tag => tag.id)],
      announceAt: H_time.getDateDashFormat(announce_at),
      effectAt: H_time.getDateDashFormat(effect_at),
      guidelineStatus: guideline_status ? guideline_status.id : '',
      scopeRoles: [user_factory_roles.map(role => role.id), user_factory_role_templates.map(role => role.id)],
      scopeAvatars: users.map(user => user.id),
      scopeAvatarsSelectValue: users,
      guidelineList: H_guidelineVersionAdmin.setUpdateRelatedGuideline(related_guidelines),
    }
  },
  setUpdateSubmit({
    owner,
    guidelineStatus: guideline_status,
    factoryTags,
    scopeAvatars: users,
    scopeRoles,
  }) {
    const {user_factory_roles, user_factory_role_templates} = H_common.setSubmitRolesAndFactoryRoles(scopeRoles);
    return {
      owner,
      guideline_status,
      factory_tags: factoryTags[0],
      users,
      user_factory_roles,
      user_factory_role_templates,
    }
  },
  setCard(rawDataList, guidelineType = 'guideline') {
    if (!rawDataList || !rawDataList.length) return [];
    return rawDataList.map(({
      id,
      last_version: {id: versionId, name, announce_at, type = '', guideline = {}, guideline_version = {}},
    }) => {
      let baseData = {
        title: `${name}${announce_at ? ` (${H_time.getDateDashFormat(announce_at)})` : ''}`,
      };
      return guidelineType === 'guideline'
        ? {
            ...baseData,
            guidelineId: id,
            guidelineVerId: versionId,
            type: 'guideline',
          }
        : {
            ...baseData,
            guidelineId: guideline.id,
            guidelineVerId: guideline_version.id,
            type,
            articleVerId: versionId,
          };
    });
  }
}